import * as axios from 'axios';
import qs from 'qs';
import { login, Headers } from "./axios_config";
import { saveState, loadState } from '../redux/helper/local_storage_helper';

const baseURL = process.env.REACT_APP_API_URL; // axios base API url
const app_user = loadState('app_user');
const Axios = axios.create({ baseURL });

/*
*Axios interceptor For checking Auth token expired, API errors and Server down
*/
Axios.interceptors.response.use(response => {
    return response;
}, error => {
    const originalRequest = error.config;
    if (app_user && error.response.status === 401 && !originalRequest._retry) {

        originalRequest._retry = true;
        return Axios.post(login.url, qs.stringify({
            grant_type: 'password',
            client_id: 'webApp',
            DeviceType: 3,
            PhoneNumber: app_user.phoneNumber
        }), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: Headers()
            }
        })
            .then(res => {
                if (res.data) {
                    // 1) put token to LocalStorage
                    saveState(res.data, 'app_user');

                    // 2) Change Authorization header
                    originalRequest.headers['Authorization'] = `${res.data.token_type} ${res.data.access_token}`;

                    // 3) return originalRequest object with Axios.
                    return Axios(originalRequest);
                }
            })
    }
    if (error.response && error.response.data && error.response.data.location && window.location.href !== error.response.data.location) {
        window.location = error.response.data.location
    }
    if (!error.response && window.location.pathname !== '/500') {
        window.location.href = '/500'
    }
    else {
        return Promise.reject(error);
    }
});

export default Axios;